export enum Direction {
    ASCENDING = 'ascending',
    DESCENDING = 'descending'
}
